import { dashBoardConstants } from '../../_constants/dashBoard.constants';

const initialState = { remove_asessement_loading : true, remove_asessement: '', remove_asessement_error: false};

export function removeAssessor(state = initialState, action) {
    switch (action.type) {
        case dashBoardConstants.REQUEST_REMOVE_ASSESSMENT:
        return {
            remove_asessement_loading: true,
            remove_asessement: '',
            remove_asessement_error: false
        };
      case dashBoardConstants.RECIEVE_REMOVE_ASSESSMENT:
        return {
            remove_asessement_loading: false,
            remove_asessement: action.remove_asessement,
            remove_asessement_error: false
        };
      case dashBoardConstants.ERROR_REMOVE_ASSESSMENT:
        return { 
            remove_asessement_loading: false,
            remove_asessement: '',
            remove_asessement_error: true
        };
      default:
        return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/dashBoard/removeAssessment.reducer.js